/**
 * Comprehensive Indian Cities dataset and search utility
 * Provides instant, zero-latency autocomplete for city inputs.
 */

export const POPULAR_CITIES = new Set([
  "Indore", "Bhopal", "Mumbai", "Delhi", "New Delhi", "Pune", "Bengaluru", "Hyderabad",
  "Ahmedabad", "Jaipur", "Kolkata", "Surat", "Lucknow", "Kanpur", "Nagpur", "Gwalior",
  "Jabalpur", "Ujjain", "Patna", "Chandigarh", "Noida", "Greater Noida", "Gurugram",
  "Faridabad", "Ghaziabad", "Vadodara", "Rajkot", "Varanasi", "Prayagraj", "Agra",
  "Meerut", "Ludhiana", "Amritsar", "Nashik", "Aurangabad", "Dewas", "Ratlam", "Satna",
  "Rewa", "Katni", "Khandwa", "Burhanpur", "Sagar", "Shivpuri", "Vidisha", "Mandsaur",
  "Neemuch", "Khargone", "Chhindwara", "Pithampur", "Ranchi", "Raipur", "Dehradun"
]);

export const INDIAN_CITIES = [
  // Madhya Pradesh
  "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna",
  "Ratlam", "Rewa", "Katni", "Singrauli", "Burhanpur", "Khandwa", "Bhind", "Chhindwara",
  "Guna", "Shivpuri", "Vidisha", "Damoh", "Mandsaur", "Khargone", "Neemuch", "Pithampur",
  "Narmadapuram", "Itarsi", "Sehore", "Betul", "Datia", "Nagda", "Harda", "Shahdol",
  "Seoni", "Shajapur", "Mandla", "Dindori", "Barwani", "Sheopur", "Ashoknagar", "Anuppur",
  "Alirajpur", "Umaria", "Tikamgarh", "Rajgarh", "Raisen", "Panna", "Narsinghpur", "Balaghat",
  "Indergarh", "Indapur", "Indri",

  // Maharashtra
  "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Kalyan-Dombivli", "Vasai-Virar",
  "Aurangabad", "Chhatrapati Sambhajinagar", "Navi Mumbai", "Solapur", "Mira-Bhayandar",
  "Bhiwandi", "Amravati", "Nanded", "Kolhapur", "Ulhasnagar", "Sangli", "Malegaon",
  "Jalgaon", "Akola", "Latur", "Dhule", "Ahmednagar", "Chandrapur", "Parbhani",
  "Ichalkaranji", "Jalna", "Ambarnath", "Bhusawal", "Panvel", "Badlapur", "Beed",
  "Gondia", "Satara", "Barshi", "Yavatmal", "Achalpur", "Osmanabad", "Dharashiv",
  "Nandurbar", "Wardha", "Udgir", "Hinganghat",

  // Delhi NCR & Haryana
  "Delhi", "New Delhi", "Noida", "Greater Noida", "Ghaziabad", "Faridabad", "Gurugram",
  "Sonipat", "Panipat", "Rohtak", "Karnal", "Hisar", "Ambala", "Yamunanagar", "Panchkula",
  "Bhiwani", "Sirsa", "Bahadurgarh", "Jind", "Thanesar", "Kaithal", "Rewari", "Palwal",

  // Rajasthan
  "Jaipur", "Jodhpur", "Kota", "Bikaner", "Ajmer", "Udaipur", "Bhilwara", "Alwar",
  "Bharatpur", "Sikar", "Pali", "Sri Ganganagar", "Chittorgarh", "Tonk", "Kishangarh",
  "Beawar", "Hanumangarh", "Dholpur", "Sawai Madhopur", "Churu", "Baran", "Jhunjhunu",
  "Nagaur", "Makrana", "Hindaun", "Gangapur City", "Bundi", "Sujangarh", "Banswara",
  "Dausa", "Dungarpur", "Jaisalmer", "Jalore", "Jhalawar", "Pratapgarh", "Rajsamand", "Sirohi",

  // Uttar Pradesh
  "Lucknow", "Kanpur", "Agra", "Varanasi", "Prayagraj", "Allahabad", "Meerut", "Bareilly",
  "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Firozabad", "Jhansi", "Muzaffarnagar",
  "Mathura", "Ayodhya", "Faizabad", "Rampur", "Shahjahanpur", "Farrukhabad", "Hapur",
  "Etawah", "Mirzapur", "Bulandshahr", "Sambhal", "Amroha", "Hardoi", "Fatehpur",
  "Raebareli", "Orai", "Sitapur", "Bahraich", "Modinagar", "Unnao", "Jaunpur", "Lakhimpur",
  "Hathras", "Banda", "Pilibhit", "Barabanki", "Basti", "Gonda", "Sultanpur", "Bijnor",
  "Deoria", "Ghazipur", "Azamgarh", "Ballia", "Mainpuri", "Lalitpur", "Shamli", "Kasganj",
  "Balrampur", "Siddharthnagar", "Kannauj", "Chandauli", "Mahoba", "Kaushambi", "Chitrakoot",

  // Gujarat
  "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh",
  "Gandhinagar", "Anand", "Navsari", "Surendranagar", "Morbi", "Nadiad", "Bharuch",
  "Porbandar", "Godhra", "Veraval", "Vapi", "Valsad", "Palanpur", "Ankleshwar", "Mehsana",
  "Bhuj", "Gandhidham", "Dahod", "Botad", "Amreli", "Deesa", "Jetpur", "Patan", "Kalol",
  "Gondal", "Vyara", "Modasa", "Himatnagar",

  // Bihar
  "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", "Darbhanga", "Bihar Sharif",
  "Arrah", "Begusarai", "Katihar", "Munger", "Chhapra", "Danapur", "Bettiah", "Saharsa",
  "Hajipur", "Sasaram", "Dehri", "Siwan", "Motihari", "Nawada", "Bagaha", "Buxar",
  "Kishanganj", "Sitamarhi", "Jamalpur", "Jehanabad", "Aurangabad (Bihar)", "Madhubani",
  "Samastipur", "Supaul", "Araria", "Gopalganj", "Madhepura", "Banka", "Jamui",

  // West Bengal
  "Kolkata", "Howrah", "Asansol", "Siliguri", "Durgapur", "Bardhaman", "Malda",
  "Baharampur", "Habra", "Kharagpur", "Shantipur", "Dankuni", "Dhulian", "Ranaghat",
  "Haldia", "Raiganj", "Krishnanagar", "Nabadwip", "Midnapore", "Jalpaiguri", "Balurghat",
  "Basirhat", "Bankura", "Purulia", "Cooch Behar", "Darjeeling",

  // Karnataka
  "Bengaluru", "Bangalore", "Mysuru", "Mysore", "Hubballi-Dharwad", "Mangaluru", "Mangalore",
  "Belagavi", "Belgaum", "Kalaburagi", "Gulbarga", "Davanagere", "Ballari", "Bellary",
  "Vijayapura", "Bijapur", "Shivamogga", "Shimoga", "Tumakuru", "Raichur", "Bidar",
  "Hosapete", "Gadag-Betageri", "Hassan", "Bhadravati", "Chitradurga", "Udupi", "Kolar",
  "Mandya", "Chikkamagaluru", "Gangavati", "Bagalkot", "Karwar",

  // Tamil Nadu
  "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Trichy", "Salem", "Tiruppur",
  "Erode", "Tirunelveli", "Vellore", "Thoothukudi", "Dindigul", "Thanjavur", "Ranipet",
  "Sivakasi", "Karur", "Udhagamandalam", "Ooty", "Hosur", "Nagercoil", "Kanchipuram",
  "Kumarapalayam", "Karaikkudi", "Neyveli", "Cuddalore", "Kumbakonam", "Tiruvannamalai",
  "Pollachi", "Rajapalayam", "Gudiyatham", "Pudukkottai", "Nagapattinam", "Namakkal",

  // Telangana & Andhra Pradesh
  "Hyderabad", "Secunderabad", "Warangal", "Nizamabad", "Khammam", "Karimnagar", "Ramagundam",
  "Mahbubnagar", "Nalgonda", "Adilabad", "Suryapet", "Miryalaguda", "Siddipet", "Jagtial",
  "Mancherial", "Visakhapatnam", "Vizag", "Vijayawada", "Guntur", "Nellore", "Kurnool",
  "Kakinada", "Rajamahendravaram", "Rajahmundry", "Kadapa", "Tirupati", "Anantapur",
  "Vizianagaram", "Eluru", "Ongole", "Nandyal", "Machilipatnam", "Adoni", "Tenali",
  "Proddatur", "Chittoor", "Hindupur", "Bhimavaram", "Madanapalle", "Guntakal", "Srikakulam",
  "Dharmavaram", "Gudivada", "Narasaraopet", "Tadipatri", "Amaravati",

  // Punjab & Chandigarh
  "Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali",
  "Hoshiarpur", "Batala", "Pathankot", "Moga", "Abohar", "Malerkotla", "Khanna",
  "Phagwara", "Muktsar", "Barnala", "Faridkot", "Firozpur", "Kapurthala", "Rajpura",

  // Chhattisgarh
  "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg", "Rajnandgaon", "Jagdalpur", "Raigarh",
  "Ambikapur", "Dhamtari", "Mahasamund", "Champa", "Bhatapara", "Kanker", "Kawardha",

  // Jharkhand
  "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro Steel City", "Deoghar", "Phusro", "Hazaribagh",
  "Giridih", "Ramgarh", "Medininagar", "Chirkunda", "Chaibasa", "Dumka",

  // Odisha
  "Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur", "Puri", "Balasore",
  "Bhadrak", "Baripada", "Jharsuguda", "Jeypore", "Bargarh", "Rayagada", "Bolangir",

  // Uttarakhand & Himachal Pradesh
  "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur", "Kashipur", "Rishikesh",
  "Nainital", "Mussoorie", "Almora", "Pithoragarh", "Kotdwar", "Shimla", "Dharamshala",
  "Solan", "Mandi", "Kullu", "Manali", "Baddi", "Nahan", "Paonta Sahib", "Una", "Chamba",

  // Kerala
  "Kochi", "Cochin", "Thiruvananthapuram", "Trivandrum", "Kozhikode", "Calicut", "Kollam",
  "Thrissur", "Alappuzha", "Alleppey", "Palakkad", "Malappuram", "Kannur", "Kottayam",
  "Kasaragod", "Pathanamthitta", "Wayanad", "Thalassery",

  // Assam & Northeast
  "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur", "Agartala",
  "Imphal", "Shillong", "Aizawl", "Kohima", "Dimapur", "Gangtok", "Itanagar",

  // Jammu & Kashmir and Ladakh
  "Srinagar", "Jammu", "Anantnag", "Baramulla", "Udhampur", "Kathua", "Sopore", "Leh", "Kargil",

  // Goa & UTs
  "Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Puducherry", "Pondicherry", "Port Blair", "Daman", "Silvassa"
];

/**
 * Search and rank cities based on user typing
 * @param {string} query - The search query typed by user (e.g. "in")
 * @param {string[]} extraCities - Custom cities extracted from existing users database
 * @param {number} limit - Maximum number of suggestions to return
 * @returns {string[]} Ranked list of matching cities
 */
export const searchCities = (query, extraCities = [], limit = 15) => {
  if (!query || typeof query !== "string") return [];
  const q = query.trim().toLowerCase();
  if (q.length === 0) return [];

  // Merge unique values
  const allSet = new Set();
  const allList = [];

  // Add extra cities first if any
  if (Array.isArray(extraCities)) {
    for (const c of extraCities) {
      if (c && typeof c === "string") {
        const clean = c.trim();
        if (clean && !allSet.has(clean.toLowerCase())) {
          allSet.add(clean.toLowerCase());
          allList.push(clean);
        }
      }
    }
  }

  // Add standard cities
  for (const c of INDIAN_CITIES) {
    if (!allSet.has(c.toLowerCase())) {
      allSet.add(c.toLowerCase());
      allList.push(c);
    }
  }

  const exactMatches = [];
  const startsWithPopular = [];
  const startsWithOther = [];
  const containsPopular = [];
  const containsOther = [];

  for (const city of allList) {
    const lower = city.toLowerCase();
    const isPopular = POPULAR_CITIES.has(city);

    if (lower === q) {
      exactMatches.push(city);
    } else if (lower.startsWith(q)) {
      if (isPopular) {
        startsWithPopular.push(city);
      } else {
        startsWithOther.push(city);
      }
    } else if (lower.includes(q)) {
      if (isPopular) {
        containsPopular.push(city);
      } else {
        containsOther.push(city);
      }
    }
  }

  // Sort alphabetically within buckets
  startsWithPopular.sort((a, b) => a.localeCompare(b));
  startsWithOther.sort((a, b) => a.localeCompare(b));
  containsPopular.sort((a, b) => a.localeCompare(b));
  containsOther.sort((a, b) => a.localeCompare(b));

  const combined = [
    ...exactMatches,
    ...startsWithPopular,
    ...startsWithOther,
    ...containsPopular,
    ...containsOther
  ];

  return combined.slice(0, limit);
};

